/** is OS iOS or not */
export function isApplePhone() {
  return Boolean([
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod'
  ].includes(navigator.platform)
  // iPad on iOS 13 detection
  || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1))
}

/** check native HLS support (on Safari) */
export function hasNativeHls(player) {
  const support = player.canPlayType("application/vnd.apple.mpegurl");

  console.log(support);
  console.log(player.canPlayType("vnd.apple.mpegurl"));
  console.log(player.canPlayType("application/x-mpegURL"));

  if (!["probably", "maybe", ""].includes(support)) {
    console.warn(`Can play type has unknown value <${support}>`);
  }

  return support === "probably" || support === "maybe";
}
